export default "__VITE_ASSET__BasSAFV5__"